/* ToolbarDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { toggleBulletList as toggleBulletListKeymap, indent as toggleIndentKeymap, toggleOrderedList as toggleOrderedListKeymap, outdent as toggleOutdentKeymap, tooltip } from '@atlaskit/editor-common/keymaps';
import { indentationMessages, listMessages } from '@atlaskit/editor-common/messages';
import { Shortcut, ToolbarDropdownTriggerWrapper, ToolbarDropdownWrapper, ToolbarExpandIcon, ToolbarSeparator } from '@atlaskit/editor-common/ui';
import { DropdownMenuWithKeyboardNavigation as DropdownMenu, ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import BulletListIcon from '@atlaskit/icon/core/migration/list-bulleted--editor-bullet-list';
import { ToolbarType } from '../types';
export function ToolbarDropdown(props) {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var disabled = props.disabled,
    isReducedSpacing = props.isReducedSpacing,
    bulletListActive = props.bulletListActive,
    orderedListActive = props.orderedListActive,
    popupsMountPoint = props.popupsMountPoint,
    popupsBoundariesElement = props.popupsBoundariesElement,
    popupsScrollableElement = props.popupsScrollableElement,
    onItemActivated = props.onItemActivated,
    pluginInjectionApi = props.pluginInjectionApi;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDropdownOpen = _React$useState2[0],
    setIsDropdownOpen = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOpenedByKeyboard = _React$useState4[0],
    setOpenedByKeyboard = _React$useState4[1];
  var labelLists = formatMessage(listMessages.lists);

  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var onOpenChange = function onOpenChange(attrs) {
    setIsDropdownOpen(attrs.isDropdownOpen);
  };
  var handleTriggerClick = function handleTriggerClick() {
    onOpenChange({
      isDropdownOpen: !isDropdownOpen
    });
  };
  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setIsDropdownOpen(!isDropdownOpen);
      setOpenedByKeyboard(true);
    }
  };
  var items = useItems(props);
  var handleOnItemActivated = function handleOnItemActivated(_ref) {
    var item = _ref.item,
      _ref$shouldCloseMenu = _ref.shouldCloseMenu,
      shouldCloseMenu = _ref$shouldCloseMenu === void 0 ? true : _ref$shouldCloseMenu;
    setIsDropdownOpen(!shouldCloseMenu);
    return onItemActivated({
      editorView: props.editorView,
      buttonName: item.value.name
    });
  };
  var reducedSpacing = props.toolbarType === ToolbarType.FLOATING ? 'compact' : 'none';
  return /*#__PURE__*/React.createElement(ToolbarDropdownWrapper, null, /*#__PURE__*/React.createElement(DropdownMenu, {
    items: items,
    onItemActivated: handleOnItemActivated,
    mountTo: popupsMountPoint,
    boundariesElement: popupsBoundariesElement,
    scrollableElement: popupsScrollableElement,
    isOpen: isDropdownOpen,
    onOpenChange: onOpenChange,
    fitHeight: 188,
    fitWidth: 175,
    shouldUseDefaultRole: true,
    shouldFocusFirstItem: function shouldFocusFirstItem() {
      if (isOpenedByKeyboard) {
        setOpenedByKeyboard(false);
      }
      return isOpenedByKeyboard;
    }
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    spacing: isReducedSpacing ? reducedSpacing : 'default',
    selected: bulletListActive || orderedListActive || isDropdownOpen,
    "aria-expanded": isDropdownOpen,
    "aria-haspopup": true,
    "aria-label": labelLists,
    disabled: disabled,
    onClick: handleTriggerClick,
    onKeyDown: handleOnKeyDown,
    title: labelLists,
    iconBefore: /*#__PURE__*/React.createElement(ToolbarDropdownTriggerWrapper, null, /*#__PURE__*/React.createElement(BulletListIcon, {
      color: "currentColor",
      spacing: "spacious",
      label: labelLists
    }), /*#__PURE__*/React.createElement(ToolbarExpandIcon, null))
  })), !(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.primaryToolbar) && /*#__PURE__*/React.createElement(ToolbarSeparator, null));
}
function useItems(props) {
  var _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  var labelUnorderedList = formatMessage(listMessages.unorderedList);
  var labelOrderedList = formatMessage(listMessages.orderedList);
  var items = [{
    key: 'unorderedList',
    content: labelUnorderedList,
    value: {
      name: 'bullet_list'
    },
    isDisabled: props.bulletListDisabled,
    isActive: Boolean(props.bulletListActive),
    elemAfter: /*#__PURE__*/React.createElement(Shortcut, null, tooltip(toggleBulletListKeymap))
  }, {
    key: 'orderedList',
    content: labelOrderedList,
    value: {
      name: 'ordered_list'
    },
    isDisabled: props.orderedListDisabled,
    isActive: Boolean(props.orderedListActive),
    elemAfter: /*#__PURE__*/React.createElement(Shortcut, null, tooltip(toggleOrderedListKeymap))
  }];
  if (props.showIndentationButtons) {
    var labelIndent = formatMessage(indentationMessages.indent);
    var labelOutdent = formatMessage(indentationMessages.outdent);
    items.push({
      key: 'outdent',
      content: labelOutdent,
      value: {
        name: 'outdent'
      },
      isDisabled: props.outdentDisabled,
      isActive: false,
      elemAfter: /*#__PURE__*/React.createElement(Shortcut, null, tooltip(toggleOutdentKeymap))
    }, {
      key: 'indent',
      content: labelIndent,
      value: {
        name: 'indent'
      },
      isDisabled: props.indentDisabled,
      isActive: false,
      elemAfter: /*#__PURE__*/React.createElement(Shortcut, null, tooltip(toggleIndentKeymap))
    });
  }
  return [{
    items: items
  }];
}